module.exports = __webpack_public_path__ + "static/media/no_condorcet_1.b5df16f9.png";